// extracted by css-extract-rspack-plugin
export default {"section":"section-module__section","title":"section-module__title","titleLine":"section-module__titleLine"};